module.exports = __webpack_public_path__ + "static/media/hour_glass.2438400f.gif";